import React from 'react';
import { Accent, accentIcon, accentBorderHover } from '../lib/accents';

export const FeatureCard: React.FC<{ icon: React.ReactNode; title: string; description: string; accent?: Accent }> = ({ icon, title, description, accent = 'primary' }) => (
  <div className={`h-full flex flex-col bg-card p-8 rounded-lg border border-border ${accentBorderHover[accent]} hover:shadow-lg transition-all duration-300`}>
    <div className={`inline-block ${accentIcon[accent]} p-3 rounded-full mb-4 self-start`}>
      {icon}
    </div>
    <h3 className="text-xl font-bold text-card-foreground mb-2 font-heading">{title}</h3>
    <p className="text-muted-foreground flex-grow">{description}</p>
  </div>
);